const ArrowLeft01Icon = /*#__PURE__*/ [
  ["path", { d: "M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowLeft01Icon as default };
//# sourceMappingURL=ArrowLeft01Icon.js.map
